import React from "react";
import { createClasses, Link } from "@bloomberg/media-ui-core";
import { useRegUIClient } from "@foundation/reg-ui-client";
import { trackClickEvent } from "@foundation/nextjs-gtm";
import styles from "./shareFeedback.module.css";

export type ShareFeedbackProps = {
  feedbackUrl: string;
  feedbackText?: string;
  showIcon?: boolean;
  className?: string;
  trackingEventLabel: string;
};

// TODO: move to media-ui and replace icon `NewWindow`
function FeedbackIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.6667 12.6667H3.33333V3.33333H8V2H2V14H14V8H12.6667V12.6667ZM9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2H9.33333Z"
        fill="black"
      />
    </svg>
  );
}

export default function ShareFeedback(props: ShareFeedbackProps) {
  const {
    className,
    feedbackUrl,
    feedbackText = "Let us know here",
    showIcon = false,
    trackingEventLabel,
  } = props;
  const { session } = useRegUIClient();
  const bconnectId = session?.userInfo?.userId;
  const feedbackSurveyUrl = `${feedbackUrl}?bconnectId=${bconnectId}`;

  const trackOnClick = () => {
    trackClickEvent("survey", trackingEventLabel, "click", "engagement");
  };

  return (
    <Link
      className={createClasses([className, styles.shareFeedbackContainer])}
      href={feedbackSurveyUrl}
      target="_blank"
      onClick={trackOnClick}
    >
      <span className={styles.feedbackTitle}>{feedbackText}</span>
      {showIcon && <FeedbackIcon />}
    </Link>
  );
}
